// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1oShI","errors":"Errors_errors__ZLE1x"};